import { Component, Input, OnInit } from '@angular/core';
import { ThemeService } from '../common/_theme/theme.service';

@Component({
  selector: 'app-x-loader',
  templateUrl: './x-loader.component.html',
  styleUrls: ['./x-loader.component.css'],
  standalone: false,
})
export class XLoaderComponent implements OnInit {
  @Input() loaderOverItem = false;
  @Input() marginTopImg = '';
  @Input() noPadding: boolean = false;
  logoBlack = '';
  logoWhite = '';

  constructor(private themeService: ThemeService) {
    this.logoBlack = this.themeService.getValueFromConfigurationThemeByKey('logoLoginBlackUrl');
    this.logoWhite = this.themeService.getValueFromConfigurationThemeByKey('logoNavUrl');
  }

  ngOnInit() {}
}
